module.exports = __webpack_public_path__ + "media/images/athletes/1771-ed3d1213c8592fb1bf9ac13a96c9c14b.png";